const DEMO_VALIDATION_ENABLED = false;

$(document).ready(function () {

    // scale labels

    let inputs = $('.input-group input, .input-group textarea');

    inputs.focusin(function () {
        $(this).addClass('scale');
    }).focusout(function () {
        if ($(this).val().trim() === '') {
            $(this).removeClass('scale');
        }
    });

    if (!DEMO_VALIDATION_ENABLED) {
        return;
    }

    // form validation

    function validateEmail(email) {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    function validateEmpty(field) {
        const re = /^[a-zA-Z]+$/;
        return re.test(field.val().trim());
    }

    function validatePhone(phone) {
        const digits = phone.replace(/[-\s\+\(\)]/g, '');
        return /^\d{7,}$/.test(digits);
    }

    function validateCaptcha() {

        let captchaResponse = grecaptcha.getResponse();

        if (captchaResponse.length === 0) {

            errorCaptcha('please, check captcha');
            return false;

        } else {

            if ($('.captcha-box').children('label').length) {

                $('.captcha-box').children('label').remove();

            }

            return true;

        }

    }

    function errorCaptcha(message) {
        if (!$('.captcha-box').children('label').length) {
            $('.captcha-box').append('<label>' + message + '</label>');
        }
    }

    function fullCheck(validateType, field) {
        if (!validateType) {
            field.parent().addClass('invalid');
            if (field.siblings('label').length < 2) {
                field.parent().append('<label style="display:block;">' + field.attr('data-error') + '</label>');
            }
        } else {
            field.parent().removeClass('invalid');
            if (field.siblings('label').length > 1) {
                field.siblings('label').eq(field.siblings('label').length - 1).remove();
            }
        }
    }

    // clear form function

    function clearForm() {
        inputs.each(function (index) {
            if (inputs.eq(index).val() !== '') {
                inputs.eq(index).val('');
                inputs.eq(index).removeClass('scale');
            }
        });
    }

    // show message

    function displaySubmitMessage($messageBlock, $contactBlock) {
        $contactBlock.animate({'opacity': '0'}, 500);
        $messageBlock.delay(300).animate({'opacity': '1'}, 500);
        setTimeout(clearForm, 1000);
        setTimeout(() => {
            $contactBlock.animate({'opacity': '1'}, 500);
            $messageBlock.animate({'opacity': '0'}, 500);
        }, 2500);
    }

    // progress button start

    function startProgress(btn) {
        btn.addClass('disable');
        btn.children('.progress-line').animate({
            'width': '100%'
        }, parseInt(btn.attr('data-progress-duration')) * 1000);
        setTimeout(function() {
            btn.removeClass('disable');
            btn.children('.progress-line').removeAttr('style');
        }, parseInt(btn.attr('data-progress-duration')) * 1000);
    }

    // progress button end

    function endProgress(btn) {
        btn.removeClass('disable');
        setTimeout(function () {
            btn.children('.progress-line').removeAttr('style');
        }, 100);
    }

    $('.newsletter-form').submit((e) => {

        e.preventDefault();

        let result = true;

        inputs.each(function (index) {
            if (inputs.eq(index).hasClass('validate_email')) {

                fullCheck(validateEmail(inputs.eq(index).val().trim()), inputs.eq(index));
                result = result && validateEmail(inputs.eq(index).val().trim());

            }

        });

        if (result) {
            displaySubmitMessage($('.message-newsletter'), $('.section--newsletter .input-group'));
        }
    });


    $('.contact-form').submit((e) => {

        e.preventDefault();

        let result = true;

        inputs.each(function (index) {
            if (inputs.eq(index).hasClass('validate_required')) {

                fullCheck(validateEmpty(inputs.eq(index)), inputs.eq(index));
                result = result && validateEmpty(inputs.eq(index));

            } else if (inputs.eq(index).hasClass('validate_email')) {

                fullCheck(validateEmail(inputs.eq(index).val().trim()), inputs.eq(index));
                result = result && validateEmail(inputs.eq(index).val().trim());

            } else if (inputs.eq(index).hasClass('validate_phone')) {

                fullCheck(validatePhone(inputs.eq(index).val().trim()), inputs.eq(index));
                result = result && validatePhone(inputs.eq(index).val().trim());

            }

        });

        result = result && validateCaptcha();

        if (result) {

            displaySubmitMessage($('.contact-box__message'), $('.contact-box__fields'));
            startProgress($('.btn--progress'));
            grecaptcha.reset();

        }

    });


});


// WEBPACK FOOTER //
// ./scripts/form.js